import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import ChatView from '../../components/shared/ChatView';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClientMessagesPage = () => {
  const { conversationId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [convo, setConvo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConvo = async () => {
      try {
        const res = await axios.get(`${API}/messages/conversations`);
        const found = res.data.find(c => c.id === conversationId);
        setConvo(found || null);
      } catch (error) { console.error('Failed to load conversation:', error); } finally { setLoading(false); }
    };
    fetchConvo();
  }, [conversationId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-12 h-12 rounded-full border-4 border-emerald-100 border-t-emerald-500 animate-spin" />
      </div>
    );
  }

  if (!convo) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400 text-sm">Conversacion no encontrada</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[calc(100vh-80px)]" data-testid="client-chat-view">
      {/* Chat Header */}
      <div className="px-4 py-3 border-b border-gray-100 bg-white/80 backdrop-blur-lg rounded-t-2xl">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/client/messages')}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors flex-shrink-0"
            data-testid="back-to-conversations"
          >
            <ArrowLeft size={16} className="text-gray-600" />
          </button>
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center shadow-lg shadow-emerald-500/20">
            <span className="text-white font-bold text-sm">{convo.distributor_name?.charAt(0)?.toUpperCase()}</span>
          </div>
          <div>
            <p className="font-bold text-gray-900 text-sm">{convo.distributor_name}</p>
            <p className="text-[10px] text-emerald-500 font-medium">Tu distribuidor</p>
          </div>
        </div>
      </div>

      {/* Chat */}
      <ChatView
        conversationId={convo.id}
        partnerName={convo.distributor_name}
        accentColor="#467322"
      />
    </div>
  );
};

export default ClientMessagesPage;
